import { render, staticRenderFns } from "./LearnerEndOfYear.vue?vue&type=template&id=5a00bada&scoped=true&"
import script from "./LearnerEndOfYear.vue?vue&type=script&lang=ts&"
export * from "./LearnerEndOfYear.vue?vue&type=script&lang=ts&"
import style0 from "./LearnerEndOfYear.vue?vue&type=style&index=0&id=5a00bada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a00bada",
  null
  
)

export default component.exports